import React from 'react';
import PropTypes from 'prop-types';
import { Col, Button } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';

const SearchControls = ({
  onSearch,
  onClear,
  searchLoading = false,
  searchDisabled = false,
  clearDisabled = false,
}) => (
  <>
    <Col xs={24} sm={24} md={8} lg={6}>
      <Button
        onClick={onSearch}
        block
        style={{ marginTop: 21 }}
        icon={<SearchOutlined />}
        loading={searchLoading}
        disabled={searchDisabled}
      >
        Buscar
      </Button>
    </Col>
    <Col xs={24} sm={24} md={8} lg={6}>
      <Button
        onClick={onClear}
        block
        style={{ marginTop: 21 }}
        icon={<DeleteOutlined />}
        disabled={clearDisabled || searchLoading}
      >
        Limpiar búsqueda
      </Button>
    </Col>
  </>
);

SearchControls.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  searchLoading: PropTypes.bool,
  searchDisabled: PropTypes.bool,
  clearDisabled: PropTypes.bool,
};

SearchControls.defaultProps = {
  searchLoading: false,
  searchDisabled: false,
  clearDisabled: false,
};

export default SearchControls;
